import script from "./EngagementTabSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./EngagementTabSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./EngagementTabSkeleton.vue?vue&type=style&index=0&id=6bee6578&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bee6578"]])

export default __exports__